import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const CloseInEmptyCircleIcon = ({
  width = "22",
  height = "22",
  style,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} style={style}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.999 1.83398C16.0589 1.83416 20.165 5.94108 20.165 11.001C20.1649 16.0607 16.0588 20.1668 10.999 20.167C5.93913 20.167 1.83221 16.0608 1.83203 11.001C1.83203 5.94098 5.93902 1.83398 10.999 1.83398ZM10.999 3.66699C6.94736 3.66699 3.66504 6.94931 3.66504 11.001C3.66521 15.0525 6.94746 18.334 10.999 18.334C15.0504 18.3338 18.3319 15.0524 18.332 11.001C18.332 6.94942 15.0505 3.66717 10.999 3.66699Z"
          fill="#D98880"
        />
        <path
          d="M10.999 1.83398C16.0589 1.83416 20.165 5.94108 20.165 11.001C20.1649 16.0607 16.0588 20.1668 10.999 20.167C5.93913 20.167 1.83221 16.0608 1.83203 11.001C1.83203 5.94098 5.93902 1.83398 10.999 1.83398ZM10.999 3.66699C6.94736 3.66699 3.66504 6.94931 3.66504 11.001C3.66521 15.0525 6.94746 18.334 10.999 18.334C15.0504 18.3338 18.3319 15.0524 18.332 11.001C18.332 6.94942 15.0505 3.66717 10.999 3.66699Z"
          stroke="white"
        />
        <path
          d="M11.0024 10.1363L14.0274 7.11133L14.8915 7.97544L11.8665 11.0004L14.8915 14.0254L14.0268 14.8896L11.0018 11.8646L7.97739 14.8896L7.11328 14.0248L10.1383 10.9998L7.11328 7.97483L7.97739 7.11194L11.0024 10.1363Z"
          fill="#9A2E22"
        />
      </svg>
    </IconWrapper>
  );
};
